export class DownloadTableData {
  table: DownloadTable;
  validationCriteria?: DownloadTableValidationCriterion[];

  constructor(tableData?: DownloadTableData) {
    this.table = tableData ? new DownloadTable(tableData.table) : null;
    this.validationCriteria = tableData ? tableData.validationCriteria : [];
  }
}

export class DownloadTable {
  slug: string;
  rows: DownloadTableRow[];
  title?: string;

  constructor(table?: DownloadTable) {
    this.slug = table?.slug || null;
    this.title = table?.title || null;
    this.rows = (table?.rows || []).map(row => new DownloadTableRow(row));
  }
}

export class DownloadTableRow {
  title?: string;
  isTitleRow: boolean;
  cells?: DownloadTableCell[];

  constructor(tableRow?: DownloadTableRow) {
    this.title = tableRow ? tableRow.title : null;
    this.isTitleRow = tableRow ? tableRow.isTitleRow : false;
    this.cells = tableRow ? (tableRow.cells || []).map(c => new DownloadTableCell(c)) : [];
  }
}

export class DownloadTableCell {
  slug: string;
  contents: DownloadTableContent[];
  contentType: DownloadTableCellType;
  contentIcon: DownloadTableCellIcons;

  constructor(tableCell?: DownloadTableCell) {
    this.slug = tableCell ? tableCell.slug : null;
    this.contents = tableCell ? (tableCell.contents || []).map(c => new DownloadTableContent(c)) : [];
    this.contentType = tableCell ? tableCell.contentType : null;
    this.contentIcon = tableCell ? tableCell.contentIcon : null;
  }
}

export class DownloadTableContent {
  slug: string;
  content: string;
  contentTitle?: string;
  openNewWindow?: boolean;
  constructor(contentItem: DownloadTableContent) {
    this.slug = contentItem?.slug;
    this.content = contentItem?.content;
    this.contentTitle = contentItem?.contentTitle;
    this.openNewWindow = contentItem?.openNewWindow || false;
  }
}

export enum DownloadTableCellType {
  TEXT = 'text',
  LINK = 'link',
  FILE = 'file',
}

export enum DownloadTableCellIcons {
  TEXT = 'icon-learniz-edit',
  LINK = 'icon-learniz-external-link',
  FILE = 'icon-learniz-file-simple',
}

export class DownloadTableValidationCriterion {
  type: DownloadTableValidationCriterionType;

  constructor(criterion?: DownloadTableValidationCriterion) {
    this.type = criterion ? criterion.type : null;
  }
}

export enum DownloadTableValidationCriterionType {
  CLICK_ALL = 'click-all',
  DOWNLOAD_ALL = 'download-all',
}
